module.exports = __webpack_public_path__ + "static/media/pause.967528c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Toolbar/icons/pause.svg
// module id = 915
// module chunks = 53